export const SELECT_PROXY = -1
export const DEPENDENCIES = 0
export const FORM = 1
export const PICKUP = 2
export const PROXY_PICKUP = 3
export const APPOINTMENT = 4
// export const LEGAL_DISCLAIMER = 5
export const PAYMENT = 5
export const FINISH = 6
